import PropTypes from 'prop-types'
import SDModal from '@/shared/components/SDComponents/SDModal/SDModal'
import AdditionalSalesModalContent from './ModalContent/AdditionalSalesModalContent'
import EkomiModalContent from './ModalContent/EkomiModalContent'
import BusinessCardModalContent from './ModalContent/BusinessCardModalContent'
import SubmissionModelContent from './ModalContent/SubmissionModelContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  selectBillingSubscriptionData,
  selectCustomerSubscriptionData,
} from '@/containers/SubscriptionFormPage/SubscriptionFormSelectors'
import useFormStatus from '../../../../containers/SubscriptionFormPage/useFormStatus'
import FeedbackModalContent from '@/shared/components/FormHeader/bones/ModalContent/FeedbackModalContent'
import { useState } from 'react'
import ClubSelectra from '@/containers/SubscriptionFormPageNew/Components/ClubSelectra/ClubSelectra'

const ModalWindowSubmission = ({ submitForm, isOpen, setIsOpen, sendRequest, isLoading, country, applicationType }) => {
  const { t } = useTranslation()
  const { formCanBeSubmitted, formSubmitted } = useFormStatus()
  const { businessCard } = useSelector(selectBillingSubscriptionData)
  const { hasAlreadyVotedFeedback } = useSelector(selectCustomerSubscriptionData)
  const [showFeedback, setShowFeedback] = useState(false)
  const submitFormModal = async event => {
    event.preventDefault()
    try {
      const result = await submitForm(event)
      const resultIsSuccess = result?.status === 200 && result?.success === true

      if (!resultIsSuccess) {
        setIsOpen(false)
        return
      }

      if (hasAlreadyVotedFeedback) {
        setIsOpen(false)
        return
      }

      setShowFeedback(true)
    } catch (e) {
      setIsOpen(false)
    }
  }

  const submissionModalContent = () => {
    return (
      <SubmissionModelContent
        submitFormModal={submitFormModal}
        formSubmitted={formSubmitted}
        formCanBeSubmitted={formCanBeSubmitted}
        hideScript={applicationType === 'telecom' && country === 'it'}
      />
    )
  }

  const sections = () => {
    return (
      <>
        <AdditionalSalesModalContent setIsOpen={setIsOpen} />
        {country !== 'it' && <EkomiModalContent sendRequest={sendRequest} isLoading={isLoading} />}
        {country === 'it' && <ClubSelectra version='legacy' />}
        {country === 'fr' && <BusinessCardModalContent businessCard={businessCard} />}
      </>
    )
  }

  if (showFeedback) {
    return (
      <SDModal
        isOpen={isOpen}
        openHandler={setIsOpen}
        sections={
          <FeedbackModalContent
            onClose={() => {
              setShowFeedback(false)
              setIsOpen(false)
            }}
          />
        }
      />
    )
  }

  return (
    <SDModal
      backgroundImage={{ image: 'scene' }}
      openHandler={setIsOpen}
      isOpen={isOpen}
      sections={sections()}
      submissionSection={submissionModalContent()}
      title={t('subscriptionForm:header.modal.title')}
    />
  )
}

ModalWindowSubmission.propTypes = {
  submitForm: PropTypes.func,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  sendRequest: PropTypes.func,
  isLoading: PropTypes.bool,
  country: PropTypes.string,
}

export default ModalWindowSubmission
